
import { Options, Vue } from 'vue-class-component';
import { BatchItem } from '@/store/cards/BatchUploaderModule';
import NButton from '@/uikit/buttons/NButton.vue';
import { Prop } from 'vue-property-decorator';

@Options({
  components: { NButton },
  emits: ['open-card']
})
export default class BatchLoaderModalResult extends Vue {
  @Prop({ type: Object, required: true })
  item!: any;

  @Prop({ type: String, required: true })
  cardType!: string;

  getStatusBadge(item: BatchItem) {
    switch (item.statistics.errorCode) {
      case 'no_objects':
        return this.$t('cards.no_objects', 'f');
      case 'detection_error':
        return this.$t('cards.detection_error', 'f');
      default:
        if (item.statistics.errorCode) return this.$t('common.error', 'f');
    }
    if (item.statistics.statusCode === 'success') {
      return this.$t('cards.success', 'f');
    }
    return '';
  }

  getResultCardTitle(cardId: number) {
    return `${this.$t('common.card', 'f')}: ${cardId}`;
  }

  goToCard(cardId: number) {
    this.$emit('open-card', cardId);
  }
}
